// extracted by mini-css-extract-plugin
module.exports = {"box":"Box_box__Jv_52","primary":"Box_primary__T4dMe","warning":"Box_warning__GU2Jw","sm":"Box_sm__wShPN","base":"Box_base__0bwnF","withBorder":"Box_withBorder__8FUdd"};